import { useState } from 'react';

const storageKey = 'mpTrialSystemId';

export const useExistingTrial = () => {
	const [hasExistingTrial, setHasExistingTrial] = useState(() => !!localStorage.getItem(storageKey));

	const rememberTrialSystem = (id) => {
		localStorage.setItem(storageKey, id);
	};

	const forgetTrialSystem = () => {
		localStorage.removeItem(storageKey);
		setHasExistingTrial(false);
	};

	return {
		hasExistingTrial,
		forgetTrialSystem,
		rememberTrialSystem,
	};
};
